<template>
  <vs-card class="cstm_vx_card mb-4" v-if="maximize == 1">
    <div slot="header" class="flex flex-wrap justify-between items-center">
      <h4>Summary</h4>
      <div class="inline-flex">
        <vs-tooltip text="Summary Settings"
          ><vs-button
            class="ml-2"
            @click="popupActivo = true"
            radius
            color="primary"
            type="filled"
            icon="insights"
          ></vs-button
        ></vs-tooltip>
      </div>
    </div>
    <div class="vx-row">
      <div
        v-for="(analytic, index) in list_of_analytics"
        :key="index"
        class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 mb-4"
      >
        <statistics-card-line
          hideChart
          class="h-full"
          :module_name="analytic.module_name"
          :icon="analytic.module_icon"
          icon-right
          :statistic="analytic.count"
          :statisticTitle="
            analytic.selected_value
              ? ` ${analytic.selected_value}`
              : analytic.option_name
          "
          :statisticSubTitle="
            analytic.selected_value != null
              ? analytic.selected_value
              : 'Nothing selected'
          "
        />
      </div>
    </div>
    <vs-popup class="medium" title="Add Summary" :active.sync="popupActivo">
      <!-- {{module_id}} -->
      <summeryMOdal
        :module="module_id"
        @savesummery="savesummery"
      ></summeryMOdal>
    </vs-popup>
  </vs-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import summeryMOdal from './summeryModal'
import { getUserAnalytics } from '@/api/analyticsSettings'

export default {
  components: {
    StatisticsCardLine,
    summeryMOdal
  },
  props: {
    value: {},
    module_id: {
      type: Number
    }
  },

  created () {
    this.getUserAnalytics()
  },
  watch: {
    get_maxi_min () {
      this.maximize = this.get_maxi_min
    }
  },
  data () {
    return {
      maximize: 0,
      module: '',
      list_of_analytics: [],
      popupActivo: false
    }
  },
  methods: {
    ...mapActions([
      'SET_ATTENDANCE_SINGLE_STUDENT_ID',
      'SET_Analytics_STATUS',
      'SET_Analytics_Maxi_Min_STATUS'
    ]),
    savesummery () {
      this.getUserAnalytics()
      this.popupActivo = false
    },
    async getUserAnalytics () {
      const customer_id = localStorage.getItem('customer_id')
      const PLATFORM_MODULE_ID = this.module_id
      try {
        const data = await getUserAnalytics(PLATFORM_MODULE_ID, customer_id, 0)
        this.list_of_analytics = data.data.data.analytics.flat()

        const view_state = data.data.data.view_state
        view_state.module_id = PLATFORM_MODULE_ID
        this.SET_Analytics_STATUS(view_state)

        const view_maxi_min = data.data.data.view_state.view_state
        this.SET_Analytics_Maxi_Min_STATUS(view_maxi_min)
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {
    ...mapGetters(['get_maxi_min']),
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>